import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MenuModule } from 'primeng/menu';
import { MomentModule } from 'ngx-moment';
import { StoreModule } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { EffectsModule } from '@ngrx/effects';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { PortalsInvoicesModule } from '@qwyk/portals/invoices';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { PortalsShipmentContainersModule } from '@qwyk/portals/shipment-containers';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { PortalsSchedulesSearchWithoutRoutingModule } from '@qwyk/portals/schedules-search';
import { PortalsShipmentTrackingEventsModule } from '@qwyk/portals/shipment-tracking-events';
import {
    MD5Pipe,
    UrlEncodePipe,
    LineBreaksPipe,
    ObjectToKVPPipe,
    SlugToTitlePipe,
    FileExtensionIconPipe,
    UserInfoTooltipComponent,
    BypassSecurityTrustResourceUrlPipe,
} from '@qwyk/ui-standalone';

import { SharedModule } from '../shared/shared.module';
import { PortalRoutingModule } from './portal-routing.module';
import { ShipmentsEffects } from './store/effects/shipments.effects';
import { shipmentsReducer } from './store/reducers/shipments.reducer';
import { PortalIndexComponent } from './components/portal-index/portal-index.component';
import { ResourceErrorComponent } from './components/resource-error/resource-error.component';

@NgModule({
    declarations: [
        PortalIndexComponent,
        ResourceErrorComponent,
    ],
    imports: [
        MD5Pipe,
        MenuModule,
        FormsModule,
        CommonModule,
        ButtonModule,
        SharedModule,
        MomentModule,
        UrlEncodePipe,
        TooltipModule,
        LineBreaksPipe,
        NgSelectModule,
        ObjectToKVPPipe,
        SlugToTitlePipe,
        TranslateModule,
        GoogleMapsModule,
        FontAwesomeModule,
        OverlayPanelModule,
        PortalRoutingModule,
        ConfirmDialogModule,
        DynamicDialogModule,
        ReactiveFormsModule,
        FileExtensionIconPipe,
        PortalsInvoicesModule,
        UserInfoTooltipComponent,
        PortalsShipmentContainersModule,
        BypassSecurityTrustResourceUrlPipe,
        PortalsShipmentTrackingEventsModule,
        PortalsSchedulesSearchWithoutRoutingModule,
        StoreModule.forFeature('portal', {
            shipments: shipmentsReducer,
        }),
        EffectsModule.forFeature([ShipmentsEffects]),
    ],
    providers: [DialogService],
    exports: [],
})
export class PortalModule {}
